import delayLoad from '@/utils/delayLoad'
export const openInstall = (options) => {
  delayLoad.delayLoadJS('//res.cdn.openinstall.io/openinstall.js').then(() => {
    // eslint-disable-next-line
    new OpenInstall({
      /* appKey必选参数，openinstall平台为每个应用分配的ID */
      appKey: 'h5b8t1',
      /* 可选参数，是否优先考虑拉起app，以牺牲下载体验为代价 */
      preferWakeup: false,
      /* 自定义遮罩的html */
      mask: function () {
        return ``
      },
      /* openinstall初始化完成的回调函数，可选 */
      onready: function () {
        if (options && options.force) {
          this.wakeupOrInstall()
        }
        var openDoms = document.querySelectorAll('.open-install')
        for (var i = 0; i < openDoms.length; i++) {
          openDoms[i].addEventListener('click', () => {
            this.wakeupOrInstall()
          })
        }
      }
      // eslint-disable-next-line
    }, OpenInstall.parseUrlParams())
  })
}
